"use client";

import { DataHandlerContext } from "../../contexts/DataHandler/DataHandler";

/**
 * @typedef {object} DataHandlerProviderProps
 * @prop {import("./DataHandler").DataHandlerContextValue} value
 * @prop {import("react").ReactNode} children
 */

/**
 * @param {DataHandlerProviderProps} props
 */
export function DataHandlerProvider({ value, children }) {
  return <DataHandlerContext.Provider value={value} children={children} />;
}
